import type { Artist } from '~/types';
import { createFileRoute } from '@tanstack/react-router';
import { useStore } from '@tanstack/react-store';
import { useEffect } from 'react';
import StageSection from '~/components/artists/StageData';
import SocialLinks from '~/components/SocialLinks';
import artistsData from '~/data/artists.json';
import { data as strings } from '~/data/basic';
import { langStore } from '~/store/langStore';
import { usePosthogEvent } from '~/utils/posthog';

export const Route = createFileRoute('/artists/')({
  component: RouteComponent,
});

function RouteComponent() {
  const locale = useStore(langStore, s => s);
  const track = usePosthogEvent();

  useEffect(() => {
    track('artists_page_view', { locale });
  }, [locale, track]);

  // Group artists by stage
  const stagesData = artistsData.reduce((acc: Record<string, Artist[]>, artist) => {
    if (!acc[artist.Stage]) {
      acc[artist.Stage] = [];
    }
    acc[artist.Stage].push(artist as Artist);
    return acc;
  }, {});

  return (
    <div className="w-full bg-blackpng bg-cover bg-no-repeat py-24 text-white">
      <div className="mx-auto flex w-[90%] flex-col gap-2 xl:w-2/3">
        <div className="flex items-start justify-between">
          <div className="flex items-center">
            <h1 className="text-3xl font-bold lg:text-4xl">
              {strings.artists.artists[locale]}
            </h1>
          </div>
          <SocialLinks />
        </div>
        {Object.entries(stagesData).map(([stage, performances]) => (
          <StageSection key={stage} stage={stage} performances={performances} onArtistClick={artist => track('artist_card_click', { artist, stage })} />
        ))}
      </div>
    </div>
  );
}
